import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveDecizieNivelRisc } from "@/api/endpoints/decizieNivelRisc";
import { queryKeys } from "@/lib/queryClient";
import type { DecizieNivelRiscInput } from "@/types/notificariRecalcul";

export function useSalveazaDecizieNivelRisc() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: DecizieNivelRiscInput) => saveDecizieNivelRisc(input),
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.decizieNivelRisc.bySession(input.session_id),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.evaluari.all });
    },
  });
}
